//
//
//
//
//
//

export default {
  name: 'AllianceParentView'
};